/* eslint-disable react/no-danger */

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:39
 * @LastEditTime: 2021-07-19 17:05:50
 * @LastEditors: wangshengqiang
 * @Description: 条款上的气泡提示
 */
import React, { useEffect, useState } from 'react'; // import { isPreviewMode } from '@/utils/tool';

import './index.less'; // content 提示内容
// enable 是否开启气泡提示
// autoHidden 是否自动隐藏
// delay 自动隐藏时间，

const BubbleTip = props => {
  const {
    attrs = {}
  } = props;
  const {
    delay = 5,
    content = '',
    enable,
    autoHidden
  } = attrs;
  const [time, setTime] = useState(delay);
  const dd = content.replace(/<[^>]+>/g, ''); // 截取html标签

  const dds = dd.replace(/&nbsp;/gi, ''); // 截取空格等特殊标签

  const isShow = enable && dds.replace(/\s*/g, '').length > 0; // const [domHeight, setDomHeight] = useState(76);

  useEffect(() => {
    setTime(delay); // if (isShow) {
    //   const height = document.getElementsByClassName('c-BubbleTip-component')[0].offsetHeight;
    //   setDomHeight(height);
    // }

    if (autoHidden) {
      const timer = setInterval(() => {
        setTime(n => {
          if (n <= 1) {
            clearInterval(timer);
          }

          return n - 1;
        });
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [autoHidden, delay, content]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShow && /*#__PURE__*/React.createElement("div", {
    className: "c-BubbleTip-component",
    style: {
      top: '50%'
    }
  }, time !== 0 && /*#__PURE__*/React.createElement("div", {
    className: "c-BubbleTip-component-content"
  }, /*#__PURE__*/React.createElement("span", {
    className: "content",
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), autoHidden && /*#__PURE__*/React.createElement("span", {
    className: "time"
  }, "(", time, "s)"))));
};

export default BubbleTip;